import FirebaseContext, { withFirebase } from './context';
import Firebase from './app';

export default Firebase;

export { FirebaseContext, withFirebase };
